
import { createContext, useMemo } from 'react';
import { ISortInfo } from '../../../../../../../BaseComponents/Table/Components/SortableTableUtils';
import { TVisningstyp } from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataSet/BusinessDataSet';
import { ICollectionDataType } from '../../../../../_Common/Components/BusinessCollectionComponents/Queries/BusinessCollectionQuery';
import { IFilterAttribute } from '../../../../../_Common/Const/Delsystem';

export interface ISchedulerFilterContext {
  onSearchTextChanged: (text: string) => void;
  searchText: string;
  sortedData: ISortInfo<ICollectionDataType>;
  filterAttributes: IFilterAttribute[] | undefined;
  listlength: number;
  sortedLength: number;
  setSearchText?: (newValue: string) => void;
  filterAttributesPlacholder?: string | undefined;
  visningsTyp: TVisningstyp;
}

const defaultValues: ISchedulerFilterContext = {
  onSearchTextChanged: () => {},
  searchText: '',
  sortedData: { rows: [], properties: [], filtered: false },
  filterAttributes: [],
  listlength: 0,
  sortedLength: 0,
  setSearchText: () => {},
  filterAttributesPlacholder: undefined,
  visningsTyp: 'tabell',
};

export const SchedulerFilterContext =
  createContext<ISchedulerFilterContext>(defaultValues);

export const SchedulerFilterContextProvider: React.FC<
  React.PropsWithChildren<ISchedulerFilterContext>
> = props => {
  const value: ISchedulerFilterContext = useMemo(
    () => ({
      onSearchTextChanged: props.onSearchTextChanged,
      searchText: props.searchText,
      sortedData: props.sortedData,
      filterAttributes: props.filterAttributes,
      listlength: props.listlength,
      sortedLength: props.sortedLength,
      setSearchText: props.setSearchText,
      filterAttributesPlacholder: props.filterAttributesPlacholder,
      visningsTyp: props.visningsTyp,
    }),
    [
      props.onSearchTextChanged,
      props.searchText,
      props.sortedData,
      props.filterAttributes,
      props.listlength,
      props.sortedLength,
      props.setSearchText,
      props.filterAttributesPlacholder,
      props.visningsTyp,
    ]
  );
  return (
    <SchedulerFilterContext.Provider value={value}>
      {props.children}
    </SchedulerFilterContext.Provider>
  );
};
